/*
 * Line the check and label up with the icon rows around it in the entity menu: the check's slot takes the
 * place of a ListItemIcon (a 20px icon and 8px of space after it).
 */
.item > [aria-hidden='true']:first-child {
  width: 20px;
  margin-inline-end: 8px;
  align-items: center;
  justify-content: center;
}
